import React from 'react'
import { useSelector } from 'react-redux'
import { sortBy } from 'lodash'

import { getStartEnd, getScheduleTypesOptions } from 'services/schedule'
import { t } from 'translations'
import Select from './Select'

const SelectScheduleType = ({ shift, shifts, setFieldValue }) => {
  const { nonFilterScheduleTypes, scheduleTypesById } = useSelector(state => state.resources)

  // Get all the schedule Types Options for the shift(s)
  const scheduleTypesOptions = getScheduleTypesOptions(shifts ? shifts : [shift])

  // If there are no scheduleTypes existing, hide the select
  if (!nonFilterScheduleTypes.length) return null
  // If there are no scheduletype without departments and no scheduletype for the position, hide the Select
  if (!scheduleTypesOptions.length) return null

  return (
    <Select
      module="manager.schedule.eventForm"
      name="selectedScheduleType"
      options={[
        { _id: 'custom', name: t('manager.schedule.eventForm.CUSTOM_SCHEDULE_TYPE') },
        ...sortBy(scheduleTypesOptions, 'startTime').map(scheduleType => ({
          _id: scheduleType._id,
          name: `${scheduleType.name} (${scheduleType.startTime} - ${scheduleType.endTime})`
        }))
      ]}
      dontSort
      handleChange={({ target: { value } }) => {
        if (value === 'custom') {
          const { start = shift.start, end = shift.end } = getStartEnd('custom', shift)
          setFieldValue('start', start)
          setFieldValue('end', end)
        } else {
          const scheduleType = scheduleTypesById[value]
          const { start = shift.start, end = shift.end } = getStartEnd(scheduleType, shift)
          setFieldValue('start', start)
          setFieldValue('end', end)
        }
      }}
    />
  )
}

export default SelectScheduleType
